import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1581.176,451.765 L112.942,451.765 L112.942,282.353 C112.942,250.729 137.788,225.882 169.412,225.882 L338.823,225.882 L338.823,282.353 C338.823,313.976 363.671,338.824 395.294,338.824 C426.918,338.824 451.765,313.976 451.765,282.353 L451.765,225.882 L1242.354,225.882 L1242.354,282.353 C1242.354,313.976 1267.2,338.824 1298.824,338.824 C1330.447,338.824 1355.294,313.976 1355.294,282.353 L1355.294,225.882 L1524.706,225.882 C1556.329,225.882 1581.176,250.729 1581.176,282.353 L1581.176,451.765 Z M1103.436,1301.082 C1103.436,1435.482 998.401,1532.611 844.8,1532.611 C716.047,1532.611 623.436,1479.529 561.318,1403.859 L651.671,1320.282 C704.753,1382.4 764.612,1416.282 847.059,1416.282 C919.341,1416.282 974.683,1373.365 974.683,1306.728 L974.683,1304.471 C974.683,1232.187 908.047,1191.529 804.141,1191.529 L744.282,1191.529 L722.823,1111.341 L922.73,902.4 L603.106,902.4 L603.106,790.588 L1092.141,790.588 L1092.141,886.588 L885.459,1094.4 C997.271,1107.953 1103.436,1164.424 1103.436,1298.823 L1103.436,1301.082 Z M1524.706,112.941 L1355.294,112.941 L1355.294,56.471 C1355.294,24.847 1330.447,0 1298.824,0 C1267.2,0 1242.354,24.847 1242.354,56.471 L1242.354,112.941 L451.765,112.941 L451.765,56.471 C451.765,24.847 426.918,0 395.294,0 C363.671,0 338.823,24.847 338.823,56.471 L338.823,112.941 L169.412,112.941 C75.671,112.941 -4.54747351e-13,188.612 -4.54747351e-13,282.353 L-4.54747351e-13,1920 L1694.118,1920 L1694.118,282.353 C1694.118,188.612 1618.447,112.941 1524.706,112.941 L1524.706,112.941 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "translate(113)"
});

var IconCalendarDaysSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCalendarDaysSolid, _Component);

  var _super = _createSuper(IconCalendarDaysSolid);

  function IconCalendarDaysSolid() {
    _classCallCheck(this, IconCalendarDaysSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCalendarDaysSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCalendarDays",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCalendarDaysSolid.displayName = "IconCalendarDaysSolid";
  return IconCalendarDaysSolid;
}(Component);

IconCalendarDaysSolid.glyphName = 'calendar-days';
IconCalendarDaysSolid.variant = 'Solid';
IconCalendarDaysSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCalendarDaysSolid;
export { IconCalendarDaysSolid };